import {useEffect} from 'react';
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import unarchive from "../../../../assets/vw/svg/unarchive.svg";
import archivar from "../../../../assets/vw/svg/archivar.svg";

const CardContenido = ({infoCard, handleArchivar, visualizar, archivo, rowDesarchivar, setShowContent}) => {
    
    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])

    return (
        <>
            <div className={"select-card-content mb-4"}>

            </div>
            <div className="select-card-footer d-flex justify-content-between">
                <div className={"ps-2 pt-2"}>
                    {
                        archivo ? (
                            <img src={inactivo_icono} alt="activo"></img>
                        ): (
                            <img className={"mr-3"} src={activo_icono} alt="activo"></img>
                        )
                    }
                </div>
                <div className={"d-flex align-items-end"}>
                    {
                        archivo ? (<></>
                        ): (
                            <>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => visualizar({row: infoCard})}
                                >
                                    <div className="d-flex font-azul-claro-secundario">
                                        <div className={"visualizar-icon-mobile mr-2"}></div>
                                        Visualizar
                                    </div>
                                </button>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar({row: infoCard})}
                                >
                                    <div className="d-flex font-amarillo-complementario">
                                        {" "}
                                        <img
                                            src={archivar}
                                            alt="archivar"
                                            className="px-2"
                                        ></img>{" "}
                                        Archivar
                                    </div>
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
        </>
    );
}

export default CardContenido;